import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DistributorComponent } from './distributor.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path:'DistributorModule', loadChildren: () => import('./distributor.module').then(m => m.DistributorModule)},
      { path: '', component: DistributorComponent }
    ])
  ],
  exports: [RouterModule]
})
export class DistributorRoutingModule { }
